import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Magnet } from "lucide-react";

const BlogHeader = () => {
  return (
    <header 
      className="fixed top-0 left-0 right-0 z-50 border-b border-border/40 bg-background/80 backdrop-blur-xl"
      role="banner"
    >
      <div className="container mx-auto flex h-16 items-center justify-between px-4">
        <Link 
          to="/" 
          className="flex items-center gap-2"
          aria-label="Ir para página inicial do Magnet Link"
        >
          <img src="/brand/app-icon.svg" alt="" aria-hidden="true" className="h-8 w-8 rounded-lg" />
          <span className="text-lg font-semibold">Magnet Link</span>
        </Link>
        
        <nav 
          className="hidden items-center gap-6 md:flex"
          role="navigation"
          aria-label="Navegação principal"
        >
          <Link 
            to="/" 
            className="text-sm text-muted-foreground transition-colors hover:text-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 rounded-sm px-2 py-1"
          >
            Início
          </Link>
          <Link 
            to="/blog" 
            className="text-sm text-foreground font-medium transition-colors hover:text-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 rounded-sm px-2 py-1"
            aria-current="page"
          >
            Blog
          </Link>
          <Link 
            to="/#features" 
            className="text-sm text-muted-foreground transition-colors hover:text-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 rounded-sm px-2 py-1"
          >
            Recursos
          </Link>
        </nav>

        {/* Mobile menu button */}
        <nav 
          className="flex items-center gap-4 md:hidden"
          role="navigation"
          aria-label="Navegação mobile"
        >
          <Link 
            to="/blog" 
            className="text-sm font-medium"
            aria-label="Ir para o blog"
          >
            Blog
          </Link>
        </nav>

        <Button asChild className="hidden sm:inline-flex">
          <Link to="/auth?mode=signup" aria-label="Criar conta gratuita no Magnet Link">
            Começar Grátis
          </Link>
        </Button>
      </div>
    </header>
  );
};

export default BlogHeader;
